<ul class="nav nav-tabs nav-fill">
  <li class="nav-item">
    <a
      class="nav-link"
      [ngClass]="{ active: isTabActive(FilterTab.Filters) }"
      (click)="switchTab(FilterTab.Filters)"
      href="javascript:void(0)"
    >
      {{ "filters.tabs.all-filters" | translate }}
    </a>
  </li>

  <li class="nav-item">
    <a
      class="nav-link"
      [ngClass]="{
        active: isTabActive(FilterTab.ActiveFilters),
        disabled: isTabDisabled(FilterTab.ActiveFilters),
      }"
      (click)="switchTab(FilterTab.ActiveFilters)"
      href="javascript:void(0)"
    >
      {{ "filters.tabs.active-filters" | translate }}
      <span *ngIf="hasActiveFilters">
        {{ activeFiltersCount }}
      </span>
    </a>
  </li>
</ul>

<!--  Selected Tab Content -->
<ng-container [ngSwitch]="currentTab">
  <!-- ✅ All Filters Tab -->
  <ng-container *ngSwitchCase="FilterTab.Filters">
    <div class="sidebar-form">
      <app-search-input
        [placeholder]="'filters-sidebar.search.placeholder' | translate"
        (inputChanged)="onSearchFilterChange($event)"
      >
      </app-search-input>
    </div>

    <div class="filters-pane">
      <div class="filters-list">
        <ng-container *ngIf="filteredFilters$ | async as filtered">
          <div
            class="filter"
            *ngFor="let filter of filtered; trackBy: trackByPropertyUri"
          >
            <div class="filter-title" (click)="toggleFilter(filter)">
              <div class="title">
                <div [innerHTML]="filter.name | highlight: searchFilter"></div>
                <div class="loading" *ngIf="filter.loading">
                  <app-loading [size]="'sm'"></app-loading>
                </div>
              </div>
              <div>
                <fa-icon
                  [icon]="
                    filter.expanded
                      ? ['fas', 'chevron-down']
                      : ['fas', 'chevron-right']
                  "
                ></fa-icon>
              </div>
            </div>

            <div
              class="filter-items"
              *ngIf="filter.expanded"
              [ngClass]="{ disabled: filter.loading }"
            >
              <div
                class="no-filter-items"
                *ngIf="
                  filter.expanded &&
                  filter.items.length == 0 &&
                  filter.offset > -1
                "
              >
                {{ "feed.filters.there-are-no-values-to-display" | translate }}
              </div>
              <div
                class="filter-item"
                *ngFor="let item of filter.items"
                [ngClass]="{
                  include: item.checked && item.type === 'include',
                  exclude: item.checked && item.type === 'exclude',
                }"
              >
                <div class="filter-item-title">
                  <span class="title">{{ item.title }}</span>
                  <span class="count">{{ item.count_posts | number }}</span>
                </div>

                <div class="filter-item-tools">
                  <sui-toggle
                    variant="filter"
                    [ngModel]="getItemCheckType(item)"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="
                      handleAllFiltersSliderChange($event, filter, item)
                    "
                  ></sui-toggle>
                </div>
              </div>
            </div>

            <div class="show-more" *ngIf="filter.expanded && filter.has_more">
              <a (click)="showMore(filter)" *ngIf="!filter.loading">
                {{ "filters.link.show-more" | translate }}
              </a>
              <span *ngIf="filter.loading">
                <fa-icon [icon]="faSpinner" animation="spin-pulse"></fa-icon>
              </span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <!-- ✅ Active Filters Tab -->
  <ng-container *ngSwitchCase="FilterTab.ActiveFilters">
    <div class="filters-pane">
      <div class="filters-list">
        <div class="selected-filters">
          <sui-accordion
            [multiple]="true"
            [value]="activeFilterOpenKeys"
            (valueChange)="activeFilterOpenKeys = $event"
          >
            <!-- group = one filter_title / one property_uri -->
            <sui-accordion-item
              *ngFor="let group of activeFilterGroups$ | async"
              [value]="group.key"
            >
              <span sui-accordion-header>
                {{ group.title }}
                <span>
                  {{ group.items.length }}
                </span>
              </span>

              <div
                class="filter-item"
                *ngFor="let item of group.items"
                [ngClass]="{
                  include: item.checked && item.type === 'include',
                  exclude: item.checked && item.type === 'exclude',
                }"
              >
                <div class="filter-item-title">
                  <span class="title">
                    <!-- Different visualization per kind -->
                    <ng-container [ngSwitch]="item.kind">
                      <!-- VALUE FILTER -->
                      <ng-container *ngSwitchCase="'value'">
                        {{ item.title || item.filter_title }}
                      </ng-container>

                      <!-- PERIOD FILTER -->
                      <ng-container *ngSwitchCase="'period'">
                        {{ getPeriodItemTitle(item) }}
                      </ng-container>
                      <!-- FALLBACK (when kind is undefined or unknown) -->
                      <ng-container *ngSwitchDefault>
                        {{ item.title || item.filter_title }}
                      </ng-container>
                    </ng-container>
                  </span>
                </div>

                <div class="filter-item-tools">
                  <sui-toggle
                    variant="filter"
                    [ngModel]="getItemCheckType(item)"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="
                      handleActiveFiltersSliderChange($event, item)
                    "
                  ></sui-toggle>
                </div>
              </div>
            </sui-accordion-item>
          </sui-accordion>
        </div>

        <div class="create-dimensions-section" *ngIf="hasActiveFilters">
          <div class="dimension-buttons">
            <sui-button
              variant="primary"
              [leadingIcon]="['fas', 'layer-group']"
              (click)="saveAsDimension()"
            >
              {{ "filters.button.save-as-dimension" | translate }}
            </sui-button>
            <sui-button
              variant="primary"
              [leadingIcon]="['fas', 'link']"
              (click)="attachAndSaveAsDimension()"
            >
              {{ "filters.button.save-and-link-to-feed" | translate }}
            </sui-button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
